import Debug from '../helpers/debug.js';
import { baseApiBuilder } from '../helpers/baseBuilder.js';
import { tenants } from './tenants/index.js';

const debug = Debug('commands:tenants');
const command = 'tenants <action>';

const desc = 'Manage tenants';

const builder = async function (yargs) {
  debug('builder', command);
  const base = await baseApiBuilder(yargs);
  return base.command(tenants);
};

const handler = async function (argv) {
  debug('handler', command, argv);
};

export { command, desc, builder, handler };
